'use strict';

import $ from 'jquery';
import modal from './modal';

/**
 * Price watch functionality
 */
class priceWatch {

  constructor() {
    // Data is initiated with own function from the target opening the modal
    this.product = null; //window.PRODUCT_PID;
    this.priceWatchPrice = null; //window.PRICEWATCH_PRICE;
  }

  init(){
    this._cacheDom();
    this._bindEvents();
  }

  _cacheDom(){

    this.$price = $('.js-price-watch-price');
    this.$priceInput = $('.js-price-watch-edit-price');

    this.$modals = {
      addWatch: $('#price-watch-add-watch'),
      editPrice: $('#price-watch-edit-price'),
      actions: $('#price-watch-actions'),
      added: $('#price-watch-added'),
      edited: $('#price-watch-edited'),
      deleted: $('#price-watch-deleted'),
      login: $('#login')
    }

    this.triggerClasses = {
      openEditPriceModal: '.js-open-edit-price-price-watch-modal',
      openAddWatchModal: '.js-open-add-price-price-watch-modal',
      openActionsModal: '.js-open-actions-price-watch-modal',
      addWatch: '.js-add-price-watch',
      editPrice: '.js-edit-price-price-watch',
      delete: '.js-delete-price-watch'
    };

    this.$modalTriggers = {
      openEditPriceModal: $(this.triggerClasses.openEditPriceModal),
      openAddWatchModal: $(this.triggerClasses.openAddWatchModal),
      openActionsModal: $(this.triggerClasses.openActionsModal),
      addWatch: $(this.triggerClasses.addWatch),
      editPrice: $(this.triggerClasses.editPrice),
      delete: $(this.triggerClasses.delete)
    }
  }

  _bindEvents(){

    // Actions menu
    $(document).on('click', this.triggerClasses.openActionsModal, (e)=>{
      this._initData(e.currentTarget);
      modal.openModal(this.$modals.actions);
    });

    // Edit
    $(document).on('click', this.triggerClasses.openEditPriceModal, (e)=>{
      this._initData(e.currentTarget);

      // Update the price input on the watch modal
      modal.openModal(this.$modals.editPrice);
    });

    // Add
    $(document).on('click', this.triggerClasses.openAddWatchModal, (e)=>{
      this._initData(e.currentTarget);
      modal.openModal(this.$modals.addWatch);
    });

    // Actions from open modal (data should already be init'd)
    $(document).on('click', this.triggerClasses.editPrice, this._editPrice.bind(this));
    $(document).on('click', this.triggerClasses.delete, this._delete.bind(this));
    $(document).on('click', this.triggerClasses.addWatch, this._addWatch.bind(this));
  }

  /**
   *  This will set the variables for the price watch actions when available from the target triggering the event
   *  (in some cases they will have already been set, when opening the actions menu the first time for example)
   * 
   *  @param target - The target initiating the event
   *  */ 

  _initData(target) {

    if ($(target).data('price')) {
      this.price = $(target).data('price');
      this.$modals.editPrice.find('input[name="price_watch_edit_price"]').val(this.price);
    }
    
    if ($(target).data('product-pid')) {
      this.product = $(target).data('product-pid');
    }
  }

  _updatePriceForUI(price){

    // Update the displayed price
    $('.js-price-watch-price.product-' + this.product).html(price);

    // Update the price on the action button data
    // Set both the data and attr for the DOM
    $('.button-edit-watch.product-' + this.product).data('price', price).attr('data-price', price);
  }

  _addWatch(){
    let price = $('input[name="price_watch_add_watch_price"]').val();
    this._doAjax('add', {price: price, product: this.product}, this.$modals.added);
  }

  _editPrice(){
    let price = $('input[name="price_watch_edit_price"]').val();
    this._doAjax('edit', {price: price, product: this.product}, this.$modals.edited);
  }

  _delete(){
    this._doAjax('delete', {product: this.product}, this.$modals.deleted);
  }

  _doAjax(endpoint, params, confirmationModal){
    $.ajax({
      url: '/api/1.0.0/price-watch/product/'+endpoint+'/',
      type: 'POST',
      data: JSON.stringify(params),
      contentType: 'application/json'
    }).done((data, textStatus, jqxhr) => {
      if (data.status === 'OK') {
        //show confirmation for add operation
        modal.openModal(confirmationModal);

        //update price to UI
        if(endpoint === 'edit') {
          this._updatePriceForUI(params.price);
        }

        //reload page to redraw UI
        if(endpoint === 'delete' || endpoint === 'add') {
          setTimeout(function(){
            location.reload();
          },2000);
        }
      }
    }).fail((jqxhr, textStatus, errorThrown) => {

      // Server response can be found here: jqxhr.responseJSON;

    });
  }
}

module.exports = new priceWatch();
